import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

function redirectIfAuthenticated(): ReturnType<CanActivateFn> {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isLoggedIn().pipe(
        take(1),
        map((isLoggedIn): boolean | UrlTree => isLoggedIn ? router.createUrlTree(['/dashboard']) : true)
    );
}

export const LoginGuard: CanActivateFn = () => redirectIfAuthenticated();
export const LoginMatchGuard: CanMatchFn = () => redirectIfAuthenticated();
